import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Typography,
} from "@mui/material";
import React from "react";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../component/Button";
import { CommonGrid2 } from "../../../common-components/StyledComponents";

export default function DialogNotInterested({
  open,
  handleClose,
  lg,
  handleApplyJob,
  notInterestedDialog,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          // maxWidth: !lg && "none",
          minWidth: !lg && "95%",
        },
      }}
    >
      <DialogActions
        sx={{ justifyContent: "space-between", paddingBottom: "0px" }}
      >
        <Typography variant="body5" marginLeft={lg ? "1rem" : "0.5rem"}>
          {"Are you sure ?"}
        </Typography>
        <Button onClick={handleClose}>
          <XCloseIco />
        </Button>
      </DialogActions>

      <DialogContent
        sx={{ padding: lg ? "20px 24px" : "15px", paddingTop: "0px" }}
      >
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography
              color="#475467"
              variant={lg ? "h5" : "body8"}
              // fontSize={16}
              fontFamily={"Inter"}
              fontWeight={500}
            >
              {"Are you not interested in applying for this Job ?"}
            </Typography>
          </Grid2>

          <CommonGrid2
            size={12}
            gap={"1rem"}
            marginTop={lg ? "1rem" : "0px"}
            display={"flex"}
            flexDirection={"column"}
          >
            <CommonButton
              value={"Yes"}
              width={"100%"}
              padding={"10px 14px"}
              variant="contained"
              fontWeight={"bold"}
              mobileFontSize="13px"
              onClick={() => handleApplyJob("I am not available")}
              disabled={notInterestedDialog.disabled}
              loading={notInterestedDialog.yesLoading}
            />
            <CommonButton
              value={"Available, but not interested in this Job"}
              width={"100%"}
              color="#344054"
              variant="outlined"
              padding={"10px 14px"}
              fontWeight={"bold"}
              mobileFontSize="13px"
              onClick={() =>
                handleApplyJob("I am available but not interested")
              }
              disabled={notInterestedDialog.disabled}
              loading={notInterestedDialog.availableLoading}
            />
            <CommonButton
              value={"Not Available, but let’s keep in touch"}
              color="#344054"
              width={"100%"}
              variant="outlined"
              padding={"10px 14px"}
              fontWeight={"bold"}
              mobileFontSize="13px"
              onClick={() =>
                handleApplyJob("I am unavailable but lets keep in touch")
              }
              disabled={notInterestedDialog.disabled}
              loading={notInterestedDialog.notAvailableLoading}
            />
          </CommonGrid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}
